import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import Select from 'react-select';
import foodbrand from "../../assets/foodbrand@2x.png";
import "./styleDomPersonal.css";
import options from './options.json';

function CompDomPersonal() {

    const navigate = useNavigate();

    const onTest = async () => {
        navigate("/AppIncodeDocument", {
            state: {
                rutaContinue: "/DataDomPersonal",
            }
        });
    };

    const [blContinue, setBlContinue] = useState(true);
    const [selectedOption, setSelectedOption] = useState(null);

    const handleSelectChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        // hacer algo con la opción seleccionada
    };

    const style = {
        control: base => ({
            ...base,
            height: "52px !important",
            borderRadius: "0.375rem !important",
            boxShadow: "none !important",
            borderColor: "#c4cbd1 !important",
            "&:hover": {
                borderColor: "#c4cbd1 !important"
            }

        })
    };

    return (
        <>
            <div className="initBack_P2 animate__animated animate__fadeIn">
                <Header
                    imgBack={true}
                    rutaBack="/DirDomPersonal"
                    title="Domicilio personal"
                    name="DirDomPersonal"
                />
                <div className="containerRender">
                    <div className="containerInfo_P2">
                        <div className="containerIdent_P2">
                            <div className="txtOp_P2">Domicilio Personal</div>
                            <div className="subTitle">Dirección donde normalmente reside o pernocta.</div>
                            <hr className="separadorLine" />
                            <div>
                                <span className="txtSubtitle">Comprabante de domicilio</span>
                                <div>
                                    <Select
                                        styles={style}
                                        value={selectedOption}
                                        onChange={handleSelectChange}
                                        options={options.map((option) => ({ value: option.value, label: option.label }))}
                                        placeholder="Selecciona el Comprobante"
                                    />
                                </div>
                            </div>
                            <hr className="lineSimple" />
                            <div className='btnContinue'>
                                {!blContinue ? (
                                    <>
                                        <button className='btnVer_P3'>
                                            <span className='txtVer_P3'>Capturar</span>
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <button className='button_P2 animate__animated animate__fadeIn' onClick={onTest}>
                                            <span className='txtButton_P2'>Capturar</span>
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer">
                    <div className="imageContainer_P2">
                        <img src={foodbrand} className="imgFooter_P2" />
                    </div>
                </div>
            </div>
        </>
    );
}

export default CompDomPersonal;
